import slugify from 'slugify';

/**
 * Canonical text→slug normalization, shared by the API's slug generation
 * (PageService.generateSlug) and the dashboard's live slug preview so the
 * preview can't drift from what the server saves.
 */
export function toSlug(value: string): string {
  return slugify(value, { lower: true, strict: true, trim: true });
}
